export const CompanyCompleteLedgerColumns = [
  {
    id: "invoice",
    title: "Invoice",
  },
  {
    id: "date",
    title: "Date",
  },
  {
    id: "desc",
    title: "Desc",
  },
  {
    id: "name",
    title: "Item Name",
  },
  {
    id: "qty",
    title: "QTY",
  },
  {
    id: "price",
    title: "U Price",
  },
  {
    id: "dr",
    title: "DR",
  },
  {
    id: "cr",
    title: "CR",
  },
  {
    id: "balance",
    title: "Balance",
  },
];
